import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import Toasted from '@/plugins/toasted'
import '@/plugins/vue-apex-charts.js'
import '@/plugins/echo.js'

export default {
    vuetify, 
    i18n
}